// extracted by mini-css-extract-plugin
export default {"textInput":"ShortText_textInput__PnsKi","content":"ShortText_content__MaksX","copyButton":"ShortText_copyButton__Oqgbd"};